<form id="searchForm" [formGroup]="searchForm" class="search-field" autocomplete="off">
  <div class="form-inline">
    <input id="filter" name="filter" autocomplete="off" class="form-control search" type="text" formControlName="filter" [placeholder]="placeholderText | translate "/>
    <span class="e-icons icon-search"></span>
  </div>
</form>
